__turbopack_context__.v({
  "WelcomePopup": "WelcomePopup-module__EK4S4q__WelcomePopup",
  "close": "WelcomePopup-module__EK4S4q__close",
  "closeButton": "WelcomePopup-module__EK4S4q__closeButton",
  "content": "WelcomePopup-module__EK4S4q__content",
  "desktop": "WelcomePopup-module__EK4S4q__desktop",
  "image": "WelcomePopup-module__EK4S4q__image",
  "mobile": "WelcomePopup-module__EK4S4q__mobile",
  "popup": "WelcomePopup-module__EK4S4q__popup",
  "popupout": "WelcomePopup-module__EK4S4q__popupout",
});
